// Keep the whole 44-point close target in the black margin when it fits.
// Otherwise place it wholly inside the picture, with the same safe-area gap.
export const landscapeCloseInsets = (width, height, safeLeft = 0, safeTop = 0) => {
    const pictureInset = Math.max(0, (width - height * 16 / 9) / 2);
    const gap = 12;
    const targetSize = 44;
    const fitsInMargin = safeLeft + gap + targetSize + gap <= pictureInset;
    return {
        left: (fitsInMargin ? safeLeft : Math.max(safeLeft, pictureInset)) + gap,
        top: safeTop + gap,
    };
};
